import React from 'react';
import { Grid } from '@mui/material';
import { SimpleDialog, ButtonLoading } from 'components';

import { makeStyles, withStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
  return {
    value: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#2b3990',
    },
    label: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#c9c9c9',
    },
    chkItem: {
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      backgroundColor: '#f4f4f4',
      padding: '10px',
      borderRadius: '4px',
      fontSize: '12px',

      alignItems: 'center',
      padding: '12px',
      margin: '4px 0',
    },
  };
});
const GuidDg = (props) => {
  const { isOpenAgentDg, setIsOpenAgentDg, data = [] } = props;
  const classes = useStyles();
  return (
    <SimpleDialog
      fullWidth
      maxWidth="sm"
      open={isOpenAgentDg}
      title=" راهنمای نوشتن چک "
      onClose={() => setIsOpenAgentDg(false)}
    >
      <Grid container alignItems="center">
        <Grid style={{ position: 'relative', width: '100%' }}>
          <Grid
            style={{
              textAlign: 'justify',
              padding: '14px 16px 3px',
              background: '#f9f9f9',
              border: '1px solid #2b39902e',
              borderRadius: '5px',
            }}
          >
            <h4 style={{ marginBottom: '15px' }}>
              کاربر گرامی ، چک به عنوان وثیقه ضمانت‌نامه را به صورت زیر پر کنید.
            </h4>
            <ul style={{ listStyle: 'none', width: '100%', lineHeight: '35px', fontSize: '12px' }}>
              <li>
                <label className={classes.label}>مبلغ : </label>
                <span className={classes.value}>120% مبلغ ضمانت‌نامه </span>
              </li>
              <li>
                <label className={classes.label}>در وجه : </label>
                <span className={classes.value}>بانک پاسارگاد</span>
              </li>
              <li>
                <label className={classes.label}>تاریخ سر رسید : </label>
                <span className={classes.value}>تاریخ روز جاری</span>
              </li>
            </ul>
          </Grid>

          <Grid md={12} xs={12} lg={12} style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse' }}>
            <ButtonLoading
              style={{ margin: '17px 0 0', width: '100%' }}
              variant="contained"
              color="primary" 
              name="بستن"
              onClick={() => setIsOpenAgentDg(false)}
            />
          </Grid>
        </Grid>
      </Grid>
    </SimpleDialog>
  );
};

export default GuidDg;
